import { MSafeAny } from '@app/shared/models/safe-any/safe-any.model';
export class VideoQualities {
  src!: string;
  type!: string;
  size!: number;
  default!: boolean;
}

export const getVideoQualities = (videos: MSafeAny[]) => {
  if (!videos) {
    return undefined;
  }

  return videos.map((video: MSafeAny) => ({
    src: video.link,
    type: 'video/mp4',
    size: video.height,
    default: video.default || false
  }));
};
